module.exports = __webpack_public_path__ + "static/img/bonus_4.292c1f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dhlw/bonus_4.png
// module id = Hh0i
// module chunks = 0